import { ValidationProvider, ValidationObserver } from "vee-validate";

export default {
  name: "CrudForm",
  props: {
    parentUrlKey: {
      type: String,
      default: ""
    },
    parentStoreName: {
      type: String,
      default: ""
    },
    parentStoreUrl: {
      type: String,
      default: null
    },
    parentUrlKeyTwo: {
      type: String,
      default: ""
    },
    parentStoreNameTwo: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: "Section"
    },
    storeName: {
      type: String,
      default: ""
    },
    labelBack: {
      type: String,
      default: "Back"
    },
    labelCancel: {
      type: String,
      default: "Cancelar"
    },
    labelSubmit: {
      type: String,
      default: "Save"
    },
    submit: {
      type: Function,
      default: () => {
        //
      }
    },
    status: {
      type: String,
      default: ""
    }
  },
  created() {
    //
  },
  computed: {
    //
  },
  methods: {
    buildRootUrl() {
      if (this.parentUrlKey && this.parentStoreName) {
        if (this.parentUrlKeyTwo && this.parentStoreNameTwo) {
          return (
            "/admin/" +
            this.parentStoreName.toLowerCase() +
            "/" +
            this.$route.params[this.parentUrlKey] +
            "/" +
            this.parentStoreNameTwo.toLowerCase() +
            "/" +
            this.$route.params[this.parentUrlKeyTwo] +
            "/" +
            this.storeName.toLowerCase()
          );
        } else {
          return (
            "/admin/" +
            this.parentStoreName.toLowerCase() +
            "/" +
            this.$route.params[this.parentUrlKey] +
            "/" +
            this.storeName.toLowerCase()
          );
        }
      } else {
        return "/admin/" + this.storeName.toLowerCase();
      }
    },
    goBack() {
      const self = this;
      if (self.parentUrlKey && self.parentStoreName) {
        if (self.parentUrlKeyTwo && self.parentStoreNameTwo) {
          self.$router.push(
            "/admin/" +
              self.parentStoreName.toLowerCase() +
              "/" +
              this.$route.params[self.parentUrlKey] +
              "/" +
              self.parentStoreNameTwo.toLowerCase()
          );
        } else {
          self.$router.push("/admin/" + self.parentStoreName.toLowerCase());
        }
      } else {
        self.$router.push("/admin/" + self.parentStoreName.toLowerCase());
      }
    }
  },
  components: {
    ValidationProvider,
    ValidationObserver
  }
};
